"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTMLModule = void 0;
const base_1 = require("./base");
class HTMLModule extends base_1.LabeledModule {
    constructor() {
        super(...arguments);
        this._type = "Html";
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        var _a;
        if (this.validate()) {
            const builderConfigModule = {
                id: this.id,
                label: this.label,
                style: this.style,
                stylesheet: (_a = this.stylesheet) !== null && _a !== void 0 ? _a : "",
                type: this.type,
            };
            if (this.className) {
                builderConfigModule.className = this.className;
            }
            if (this.tag) {
                builderConfigModule.tag = this.tag;
            }
            return builderConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        var _a;
        const { label, stylesheet, ...rest } = this.toBuilderConfig();
        return {
            ...rest,
            actionRequired: this.actionRequired,
            // on error, sanitized html is null, so we can combine error handling
            content: (_a = label === null || label === void 0 ? void 0 : label[this.languageCode]) !== null && _a !== void 0 ? _a : "",
            stylesheet: stylesheet !== null && stylesheet !== void 0 ? stylesheet : "",
        };
    }
    editProps() {
        var _a;
        return {
            id: this.id,
            hidden: this.hidden,
            type: this.type,
            question: (_a = this.label[this.languageCode]) !== null && _a !== void 0 ? _a : "",
            actionRequired: this.actionRequired,
        };
    }
}
exports.HTMLModule = HTMLModule;
//# sourceMappingURL=Html.js.map